// extracted by mini-css-extract-plugin
export var box = "_3k-0";
export var check = "_3k-1";
export var checkboxButton = "_3k-6";
export var checkboxGroup = "_3k-5";
export var disabled = "_3k-7";
export var ghost = "_3k-9";
export var input = "_3k-2";
export var label = "_3k-4";
export var normal = "_3k-8";
export var uncheck = "_3k-3";